/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';

const useModelUrl= () => {
    const [state, setState] = useContext(CotizadorContext)



    const setModelUrl= (model_url) => {
        setState((prevState) => ({
            ...prevState,
            model_url,
        }));
    };

    return {
        model_url: state.model_url,
        setModelUrl,
    };
}

export default useModelUrl;